if (typeof NodeList.prototype.forEach == "undefined") {
  NodeList.prototype.forEach = function (cb) {
    for (var i = 0; i < this.length; i++) {
      var node = this[i];
      cb(node, i);
    }
  };
}
var modalVideoPlayer = function modalVideoPlayer() {
  function createModalMovie(movieUrl) {
    var modalIframeWrapper = document.querySelector('.x-movie-iframe');
    var iframeUrl = 'https://www.youtube.com/embed/' + movieUrl + '?rel=0&amp;showinfo=0;autoplay=1';
    var videoModal = document.querySelector('.x-modal-video');
    modalIframeWrapper.src = iframeUrl;
    videoModal.classList.add('modal--visible');
  }
  var movieModalTrigger = document.querySelectorAll('.x-movie');
  movieModalTrigger.forEach(function (element) {
    element.addEventListener('click', function (e) {
      var movieUrl = element.dataset.url;
      createModalMovie(movieUrl);
      e.preventDefault();
    });
  });
  function modalDestroy() {
    var modalIframeWrapper = document.querySelector('.x-movie-iframe');
    var videoModal = document.querySelector('.x-modal-video');
    videoModal.classList.remove('modal--visible');
    modalIframeWrapper.src = "";
  }
  var closeMovie = document.querySelector('.x-close-movie');
  if (document.body.contains(closeMovie)) {
    closeMovie.addEventListener('click', function (e) {
      modalDestroy();
      e.preventDefault();
    });
  }
};
modalVideoPlayer();
